<app-validation-warning-dialog
    [failed]="failedCount"
    [total]="jobIds.length"
    [isOpen]="isValidationModalOpen"
    (confirm)="onProceed()"
></app-validation-warning-dialog>
<ui-dialog
    size="small"
    [open]="isWarningModalOpen"
    header="Confirm Employer Account"
    (closing)="isWarningModalOpen = false"
>
    <p>
        If you change your employer account, Indeed jobs integrated with your current account in Humi will be removed.
        Are you sure you want to continue?
    </p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="isWarningModalOpen = false">Cancel</ui-button>
        <ui-button type="primary" (click)="confirmed = true; onSave()">Confirm</ui-button>
    </ui-dialog-footer>
</ui-dialog>
<div class="ui basic segment" [class.loading]="isLoading || isSaving">
    <app-header title="Indeed Integration Settings" [back]="true"></app-header>
    <app-job-posting-card [(isIndeedJobSyncEnabled)]="isIndeedJobSyncEnabled"></app-job-posting-card>
    @if (isIndeedJobSyncEnabled) {
        <app-quick-apply-card [(integrationIndeed)]="integrationIndeed"></app-quick-apply-card>
    }
    <div class="flex width-full justify-end">
        <ui-button type="primary" (click)="onSave()">Save <mat-icon svgIcon="chevronRight"></mat-icon></ui-button>
    </div>
</div>
